document.addEventListener('DOMContentLoaded', function() {
  const mediaRoot = document.querySelector('[id^="MainProduct-"]') || document;
  const zoomImages = mediaRoot.querySelectorAll('.product__media img, .product-media img');

  let overlay = document.querySelector('.anomxly-zoom-overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.className = 'anomxly-zoom-overlay';
    document.body.appendChild(overlay);
  }

  function closeAllZoom() {
    mediaRoot.querySelectorAll('.anomxly-zoomed').forEach(img => img.classList.remove('anomxly-zoomed'));
    overlay.classList.remove('active');
  }

  zoomImages.forEach(img => {
    if (img.closest('[data-media-type="video"], [data-media-type="model"], .thumbnail-list')) return;
    img.style.transition = 'transform 0.25s ease';
    img.addEventListener('click', function(e) {
      e.stopPropagation();
      const on = img.classList.contains('anomxly-zoomed');
      closeAllZoom();
      if (!on) {
        img.classList.add('anomxly-zoomed');
        overlay.classList.add('active');
      }
    });
  });

  overlay.addEventListener('click', closeAllZoom);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeAllZoom(); });
});
